export default "__VITE_ASSET__DZRntUX0__"